/* eslint-disable @typescript-eslint/no-explicit-any */
declare let dataLayer: any;
declare let $$epiforms: any;
declare let epi: any;

export const formDataLayerPush = () => {
  window.addEventListener('load', () => {
    if (typeof $$epiforms !== "undefined") {
      epi.EPiServer.Forms.AsyncSubmit = true;

      $$epiforms(document).ready(() => {
        $$epiforms(".EPiServerForms").on("formsSubmitted", (event: { isFinalizedSubmission: boolean; isSuccess: boolean; }) => {
          if (event.isFinalizedSubmission && event.isSuccess) {

            if (typeof dataLayer !== "undefined") {

              const interests = document.querySelector<HTMLInputElement>('input[id="interest-for-data-layer"]')?.value ?? new URLSearchParams(document.location.search).get("selectedInterests");
              const category = document.querySelector<HTMLInputElement>('input[id="categories-for-data-layer"]')?.value;
              const product = document.querySelector<HTMLInputElement>('input[id="products-for-data-layer"]')?.value;
              const countries = document.querySelector<HTMLInputElement>('input[id="countries-for-data-layer"]')?.value.split(',');

              if (interests || category || product) {
                dataLayer.push({
                  "event": "contact_form",
                  "area_of_interest": interests,
                  "product_group_of_interest": category,
                  "product_of_interest": product,
                  "countries_of_delivery": countries,
                });
              }
            }
          }
        });
      });
    }
  });
}